module.exports = "<vue-component name=\"UserEvents\" v-props-user-uuid=\"ctrl.uuid\"></vue-component>\n";